import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';
import MembershipPromoBannerDefaultText from './MembershipPromoBannerDefaultText';
import { getContentWithFallback } from '../../utils/membershipPromoBanner';

const MembershipPromoBannerText = ({
  text,
  currentLanguage,
  defaultTextConditions,
  t,
}) => {
  const { display } = text;

  if (!text || display === 'default')
    return (
      <MembershipPromoBannerDefaultText
        defaultTextConditions={defaultTextConditions}
        t={t}
      />
    );
  if (display === 'hidden') return null;
  if (display === 'custom') {
    const content = getContentWithFallback(
      text.custom_content,
      currentLanguage,
    );

    if (!content) return null;

    return (
      <Box gap="8px" padding="0 0 24px 0" color="#888888">
        <Box whiteSpace="pre-wrap">{content.title}</Box>
        <Box whiteSpace="pre-wrap">{content.content}</Box>
      </Box>
    );
  }

  return null;
};

MembershipPromoBannerText.propTypes = {
  text: PropTypes.shape({
    display: PropTypes.oneOf(['default', 'hidden', 'custom']),
    custom_content: PropTypes.objectOf(
      PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
  }),
  currentLanguage: PropTypes.string,
  defaultTextConditions: PropTypes.shape({
    hasUserCredits: PropTypes.bool,
    hasMembershipTiers: PropTypes.bool,
    hasMemberPoints: PropTypes.bool,
    defaultMembershipPromoBanner: PropTypes.shape({
      birthday_credits: PropTypes.bool,
      earn_points_from_order: PropTypes.bool,
      membership_tier_discount: PropTypes.bool,
      welcome_credits: PropTypes.number,
    }),
  }),
  t: PropTypes.func,
};

export default MembershipPromoBannerText;
